var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50008 0C3.36014 0.00481897 0.00491298 3.53908 0 7.90078C0 9.93528 1.49541 13.1194 4.44472 17.3642C5.67652 19.1418 8.04288 19.5311 9.73024 18.2334C10.0464 17.9903 10.3247 17.697 10.5553 17.3642C13.5046 13.1194 15 9.93528 15 7.90078C14.9953 3.53908 11.64 0.00481897 7.50008 0Z",
    fill: "#C10606"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.77302 2.8241C8.93013 2.91352 9.04518 3.00615 9.04484 3.20962L8.6851 6.665C8.75842 7.0557 9.28746 7.09425 9.38757 6.69767C9.52477 5.76403 9.55911 4.79453 9.69579 3.86375C9.69905 3.84126 9.68806 3.81199 9.72859 3.82877C9.83213 3.87178 10.1021 4.09559 10.2008 4.17948C11.219 5.04493 11.8533 6.42102 11.9231 7.78729C11.9299 7.92258 11.943 8.25402 11.9222 8.37235C11.9176 8.39859 11.9107 8.41608 11.8885 8.43072H3.31793C3.29561 8.41608 3.28874 8.39841 3.28428 8.37235C3.26333 8.25366 3.27655 7.9233 3.28342 7.78729C3.36224 6.20292 4.18216 4.66852 5.47789 3.82877C5.52545 3.82234 5.50622 3.83251 5.51068 3.86375C5.64754 4.79453 5.68171 5.76421 5.8189 6.69767C5.91901 7.09425 6.44805 7.0557 6.52137 6.665L6.16164 3.20962C6.16129 3.00597 6.27634 2.91352 6.43346 2.8241H8.77285H8.77302Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.56445 9.85571V9.62208C2.64447 9.39255 2.80536 9.21139 3.04799 9.17802L12.137 9.17712C12.8058 9.2644 12.8077 10.2095 12.137 10.3005L3.04799 10.2996C2.80554 10.2662 2.64447 10.0851 2.56445 9.85553V9.85571Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerRed);
export default __webpack_public_path__ + "static/media/MarkerRed.9861e22c08a5566196caa3a30e99faf3.svg";
export { ForwardRef as ReactComponent };